import { axiosInstance } from "helpers";

export const getPagesSettings = async (website_id) => {
  return axiosInstance
    .get("allfeaturesettings", {
      params: {
        api_key: localStorage.getItem("apikey"),
        tab_hint: "post_sync",
        website_id: website_id,
      },
    })
    .then((response) => response.data);
};

export const updatePagesSettings = async (website_id, data) => {
  return axiosInstance
    .post("updatefeaturesettings", {
      api_key: localStorage.getItem("apikey"),
      tab_hint: "post_sync",
      website_id: website_id,
      ...data,
    })
    .then((response) => response.data);
};
